import { render, staticRenderFns } from "./EditDataModel.vue?vue&type=template&id=175384ea&"
import script from "./EditDataModel.vue?vue&type=script&lang=ts&"
export * from "./EditDataModel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports